export const vision = [
  {
    name: 'Aetna Vision Preferred - High',
    biweeklySelf: 5.68,
    biweeklySelfPlus: 11.34,
    biweeklyFamily: 17.02,
    monthlySelf: 12.31,
    monthlySelfPlus: 24.57,
    monthlyFamily: 36.88,
    website: 'https://www.aetnafeds.com/fedvip-vision.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Vision Preferred - Standard',
    biweeklySelf: 3.17,
    biweeklySelfPlus: 6.33,
    biweeklyFamily: 9.5,
    monthlySelf: 6.87,
    monthlySelfPlus: 13.72,
    monthlyFamily: 20.58,
    website: 'https://www.aetnafeds.com/fedvip-vision.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Vision - High',
    biweeklySelf: 5.66,
    biweeklySelfPlus: 11.31,
    biweeklyFamily: 16.97,
    monthlySelf: 12.26,
    monthlySelfPlus: 24.51,
    monthlyFamily: 36.77,
    website: 'https://bcbsfepvision.com/benefit-info/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Vision - Standard',
    biweeklySelf: 3.56,
    biweeklySelfPlus: 7.12,
    biweeklyFamily: 10.68,
    monthlySelf: 7.71,
    monthlySelfPlus: 15.43,
    monthlyFamily: 23.14,
    website: 'https://bcbsfepvision.com/benefit-info/',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'The MetLife Federal Vision Plan - High',
    biweeklySelf: 5.53,
    biweeklySelfPlus: 11.05,
    biweeklyFamily: 16.58,
    monthlySelf: 11.98,
    monthlySelfPlus: 23.94,
    monthlyFamily: 35.92,
    website: 'https://fedvip.metlife.com/vision/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Vision Plan - Standard',
    biweeklySelf: 3.67,
    biweeklySelfPlus: 7.34,
    biweeklyFamily: 11.01,
    monthlySelf: 7.95,
    monthlySelfPlus: 15.9,
    monthlyFamily: 23.86,
    website: 'https://fedvip.metlife.com/vision/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'UnitedHealthcare Vision Plan - High',
    biweeklySelf: 5.71,
    biweeklySelfPlus: 11.41,
    biweeklyFamily: 17.12,
    monthlySelf: 12.37,
    monthlySelfPlus: 24.72,
    monthlyFamily: 37.09,
    website:
      'https://fedvip.myuhcvision.com/MWP/public/page/fedvip_cost_coverage',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Vision Plan - Standard',
    biweeklySelf: 3.74,
    biweeklySelfPlus: 7.48,
    biweeklyFamily: 11.22,
    monthlySelf: 8.1,
    monthlySelfPlus: 16.21,
    monthlyFamily: 24.31,
    website:
      'https://fedvip.myuhcvision.com/MWP/public/page/fedvip_cost_coverage',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'VSP Vision Care - High',
    biweeklySelf: 6.72,
    biweeklySelfPlus: 13.46,
    biweeklyFamily: 20.19,
    monthlySelf: 14.56,
    monthlySelfPlus: 29.16,
    monthlyFamily: 43.75,
    website: 'https://www.choosevsp.com/cost-and-coverage.html',
    logo: 'https://vsp.widen.net/s/wcwjl6tfh7/vsp_only_logotype_rgb',
  },
  {
    name: 'VSP Vision Care - Standard',
    biweeklySelf: 3.58,
    biweeklySelfPlus: 7.16,
    biweeklyFamily: 10.75,
    monthlySelf: 7.76,
    monthlySelfPlus: 15.51,
    monthlyFamily: 23.29,
    website: 'https://www.choosevsp.com/cost-and-coverage.html',
    logo: 'https://vsp.widen.net/s/wcwjl6tfh7/vsp_only_logotype_rgb',
  },
]
